import { supabase } from "../supabase/supabase";

interface IFeedback {
    id?: number;
    contentRating?: number;
    visualsRating?: number;
    overallRating?: number;
    comment?: string;
}

export class Feedback {
    id: number;
    contentRating: number;
    visualsRating: number;
    overallRating: number;
    comment: string;

    constructor(id: number, contentRating: number, visualsRating: number, overallRating: number, comment: string) {
        this.id = id;
        this.contentRating = contentRating;
        this.visualsRating = visualsRating;
        this.overallRating = overallRating;
        this.comment = comment;
    }

    static fromJson(json: IFeedback) {
        return new Feedback(
            json.id ? json.id as number : 0,
            json.contentRating ? json.contentRating as number : 0,
            json.visualsRating ? json.visualsRating as number : 0,
            json.overallRating ? json.overallRating as number : 0,
            json.comment ? json.comment as string : "",
        );
    }

    static async addNewFeedback(contentRating: number, visualsRating: number, overallRating: number, comment: string) {
        const { data, error } = await supabase
            .from("Feedbacks")
            .insert({
                contentRating: contentRating,
                visualsRating: visualsRating,
                overallRating: overallRating,
                comment: comment,
            })
    }
}